import { alpha } from "@mui/material";

const styles = (theme) => ({
	container: { display: "flex", flexDirection: "column", gap: 1, p: 1 },
	boxTitle: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		alignItems: "center",
	},
	titleIcon: { fontSize: "22px", mt: "-2px" },
	deleteIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	addOnuOption: {
		display: "flex",
		alignItems: "center",
		gap: 8,
	},
	boxMapOnus: {
		backgroundColor:
			theme.palette.mode === "dark"
				? alpha(theme.palette.colors.black.dark, 0.4)
				: theme.palette.colors.black.lighter,
		p: 2,
		borderRadius: 4,
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	paperOnuItem: {
		p: 2,
		borderRadius: 4,
		display: "flex",
		flexGrow: 1,
		minHeight: "70px",
	},
	addDeviceIcon: { fontSize: "22px" },
	hostFieldTooltip: {
		maxHeight: 200,
		overflowY: "auto",
		p: 1,
	},
	hostFieldText: { fontSize: 10 },
	hostFieldTextSelected: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		maxWidth: "100%",
	},
	hostFieldTextCounter: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		maxWidth: "100%",
	},
	button: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: 4,
		ml: 0,
		mr: 3.5,
		color: theme.palette.text.main,
		borderColor: `${theme.palette.primary.main}42`,
		bgcolor: `${theme.palette.primary.main}10`,
	},
	boxInterfaceTags: {
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
		mt: 0.5,
	},
	interfaceTagRow: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		flexWrap: "wrap",
	},
	interfaceTagName: {
		minWidth: 120,
		maxWidth: 200,
		fontWeight: 500,
	},
	// Estilos replicados do blocosEasyFlow para a coluna de tags
	containerDatagridTags: {
		display: "flex",
		justifyItems: "start",
		alignItems: "center",
		flexWrap: "wrap",
		width: "100%",
		maxWidth: "230px",
		gap: 0.5,
		overflow: "hidden",
		minWidth: 0,
	},
	buttonTag: {
		width: "100%",
		display: "flex",
		justifyContent: "start",
		maxWidth: "160px",
		minHeight: "100%",
		p: "1px 4px",
	},
	chipTag: {
		margin: "3px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontWeight: "bold",
		color: theme.palette.white.main,
		fontSize: "0.7rem",
		minWidth: 0,
	},
	containerTagsList: {
		maxHeight: "200px",
		overflowY: "scroll",
		overflowX: "hidden",
	},
	boxInfoTag: {
		display: "flex",
		flexDirection: "column",
		p: 1,
		alignItems: "center",
	},
	textInfoTag: { fontWeight: "bold", opacity: 0.5, fontSize: "0.8rem" },
	chipCountTag: {
		height: 18,
		fontSize: "0.65rem",
		color: theme.palette.white.main,
		fontWeight: "bold",
		backgroundColor: "chip.main.arquive",
	},
	textNoTag: {
		fontSize: "0.875rem",
		fontWeight: 500,
		fontWeight: "bold",
	},
	containerHandleButtons: {
		margin: "10px",
		display: "flex",
		justifyContent: "end",
		gap: 1,
	},
	colorSelectChip: {
		height: "15px",
		width: "15px",
		margin: "3px 10px",
	},
	chipRenderTag: {
		height: "auto",
		"& .MuiChip-label": {
			display: "block",
			whiteSpace: "normal",
		},
		color: theme.palette.white.main,
	},
	buttonDeleteTag: {
		width: "100%",
		justifyContent: "start",
		padding: "10px 0",
		color: theme.palette.text.main,
	},
});

export default styles;
